import { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './styles.module.scss';

const ProductForm = ({
  productDescription,
  setProductDescription,
  title,
  setTitle,
  mode = 'form',
  reviewData,
  hasTAMMGuideline,
  setHasTAMMGuideline,
}) => {
  const isDisplayMode = useMemo(() => mode === 'display', [mode]);

  const displayTitle = useMemo(
    () => reviewData?.title || title || 'No title provided',
    [reviewData?.title, title]
  );

  const displayProduct = useMemo(
    () => reviewData?.audit_data?.product || productDescription || 'No product description provided',
    [reviewData?.audit_data, productDescription]
  );

  return (
    <div
      className={cn(
        'flex flex-col gap-8',
        {
          'pt-16': !isDisplayMode,
        }
      )}
    >
      {/* Title */}
      <div className="flex flex-col gap-8 2xl:gap-12">
        <label className="text-base font-medium text-gray-900 h-5">
          Title
        </label>
        <input
          value={isDisplayMode ? displayTitle : title}
          onChange={e => setTitle(e.target.value)}
          placeholder={'Name of review'}
          readOnly={isDisplayMode}
          className={cn(
            'w-full rounded-lg text-sm resize-none focus:outline-none p-3 2xl:mb-3 mb-8',
            {
              'bg-gray-50 text-gray-500 border-0': isDisplayMode,
              // eslint-disable-next-line max-len
              'border border-gray-300 text-gray-600 placeholder-gray-500 focus:ring-2 focus:ring-primary-400 focus:border-transparent': !isDisplayMode,
            }
          )}
        />
        <label className="text-base font-medium text-gray-900 h-5">
          Service Context
        </label>
        <textarea
          value={isDisplayMode ? displayProduct : productDescription}
          onChange={e => setProductDescription(e.target.value)}
          placeholder="Describe the service you want to review. (e.g. This is a platform that
            helps users secure a lease)"
          readOnly={isDisplayMode}
          className={cn(
            'w-full rounded-lg text-sm resize-none focus:outline-none p-3 2xl:mb-3 mb-8 min-h-20',
            {
              'bg-gray-50 text-gray-500 border-0': isDisplayMode,
              // eslint-disable-next-line max-len
              'border border-gray-300 text-gray-600 placeholder-gray-500 focus:ring-2 focus:ring-primary-400 focus:border-transparent max-h-28 h-1/2 2xl:h-16': !isDisplayMode,
            }
          )}
        />
        <label className="text-base font-medium text-gray-900 h-5">
          Guidelines
        </label>
        <div className={styles['guidelines-container']}>
          <label className={styles['guidelines-checkbox']}>
            <input
              id="tamm-standard"
              className={styles['checkbox-input']}
              type="checkbox"
              checked={hasTAMMGuideline}
              onChange={() => setHasTAMMGuideline(!hasTAMMGuideline)}
            />
            <span>
              TAMM Spaces Services Onboarding Guidelines
            </span>
          </label>

          <label className={styles['guidelines-checkbox']}>
            <input
              id="service-standard"
              className={styles['checkbox-input']}
              type="checkbox"
              checked
              disabled
            />
            <span>
              Digital Service Usability & Accessibility Standards
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

ProductForm.propTypes = {
  productDescription: PropTypes.string,
  setProductDescription: PropTypes.func,
  title: PropTypes.string,
  setTitle: PropTypes.func,
  mode: PropTypes.oneOf(['form', 'display']),
  reviewData: PropTypes.shape({
    title: PropTypes.string,
    audit_data: PropTypes.string,
  }),
  hasTAMMGuideline: PropTypes.bool.isRequired,
  setHasTAMMGuideline: PropTypes.func.isRequired,
};

ProductForm.defaultProps = {
  productDescription: '',
  setProductDescription: () => {},
  title: '',
  setTitle: () => {},
  mode: 'form',
  reviewData: {},
};

export default ProductForm;
